"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7872],{

/***/ 947872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header3; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/Header3/index.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: sticky;\n  width: 100%;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 75px;\n  color: ",
        ";\n  background: ",
        ";\n  border-bottom: 1px solid transparent;\n  z-index: 10;\n  border-color: #efefef;\n  box-shadow: 0px 0px 5px 0px #00000040;\n\n  @media screen and (max-width: 766px) {\n    height: 60px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  height: auto;\n  z-index: 10;\n\n  @media screen and (min-width: 767px) {\n    padding: 1rem 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    padding: 0rem 1rem;\n  }\n\n  @media screen and (max-width: 400px) {\n    padding: 0rem 0.2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  @media screen and (min-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  @media screen and (max-width: 766px) {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-transform: uppercase;\n  cursor: pointer;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 700;\n\n  @media screen and (min-width: 767px) {\n    font-size: 24px;\n    letter-spacing: 1.4px;\n    display: -webkit-box;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    letter-spacing: 1.4px;\n    display: ",
        ";\n  }\n\n  @media screen and (max-width: 350px) {\n    max-width: 140px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  flex: 0;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  z-index: 2;\n  background: ",
        ";\n  color: ",
        ";\n  top: 0;\n  right: 0;\n  transform: translateX(50%) translateY(-50%);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.62);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  width: 100%;\n  height: fit-content;\n  position: fixed;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  background: ",
        ";\n  color: ",
        ";\n  padding-top: ",
        "px;\n  max-height: 100vh;\n  z-index: 5;\n  box-shadow: 0px 2px 5px -2px rgba(0, 0, 0, 0.5);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-height: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow-y: auto;\n  border-bottom: 0.5px solid rgba(255, 255, 255, 0.07);\n  max-height: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: ",
        ";\n  width: 100%;\n  ",
        ";\n  padding: 14px 1rem;\n  justify-content: ",
        ";\n  align-items: ",
        ";\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: 'flex';\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 1rem 2rem;\n  font-size: 15px;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > div {\n    margin: 10px 0;\n  }\n\n  & > div:first-child {\n    margin-top: 0;\n  }\n\n  & > div:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 15px;\n  align-items: center;\n\n  & > p {\n    margin-left: 10px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  color: ",
        ";\n  position: relative;\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  margin-left: 15px;\n  height: ",
        ";\n  width: ",
        ";\n  transform: ",
        ";\n  position: relative;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  width: fit-content;\n  top: 39px;\n  left: -1rem;\n  background: ",
        ";\n  color: ",
        ";\n  box-shadow: 0px 2px 5px -2px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  min-width: 100px;\n  overflow: hidden;\n  padding: 0.5rem 1rem;\n  max-height: 400px;\n  overflow-y: auto;\n  width: 250px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n  box-sizing: border-box;\n  width: 100%;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  flex: 0;\n  cursor: pointer;\n  font-size: 14px;\n  width: 100%;\n  color: ",
        ";\n  padding: 10px 0px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}

var HeaderComponent = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "HeaderComponent",
    componentId: "sc-cad8f88c-0"
})(_templateObject(), function(props) {
    return props.secondaryColor;
}, function(props) {
    return props.primaryColor;
});
var HeaderInner = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeaderInner",
    componentId: "sc-cad8f88c-1"
})(_templateObject1());
var HeaderSections = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderSections",
    componentId: "sc-cad8f88c-2"
})(_templateObject2());
var MobileHeader = (0,styled_components_browser_esm/* default */.ZP)(HeaderSections).withConfig({
    displayName: "MobileHeader",
    componentId: "sc-cad8f88c-3"
})(_templateObject3());
var DesktopHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DesktopHeader",
    componentId: "sc-cad8f88c-4"
})(_templateObject4());
var StoreName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "StoreName",
    componentId: "sc-cad8f88c-5"
})(_templateObject5(), function(props) {
    return props.fontColor;
}, function(props) {
    return props.showStoreNameOnMobile ? "-webkit-box" : "none";
});
var CartTotalContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CartTotalContainer",
    componentId: "sc-cad8f88c-6"
})(_templateObject6(), function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.fontColor;
});
// Mobile Dropdown Styles
var MobileDropownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileDropownContainer",
    componentId: "sc-cad8f88c-7"
})(_templateObject7());
var MobileHeaderDrawer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileHeaderDrawer",
    componentId: "sc-cad8f88c-8"
})(_templateObject8(), function(props) {
    return props.isOpen ? "flex" : "none";
}, function(props) {
    return props.primaryColor;
}, function(props) {
    return props.secondaryColor;
}, function(props) {
    return props.paddingTop || 0;
});
var HeaderDrawerInner = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeaderDrawerInner",
    componentId: "sc-cad8f88c-9"
})(_templateObject9(), function(props) {
    return "calc(100vh - ".concat(props.heightLimiter, "px)");
});
var HeaderExpandable = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeaderExpandable",
    componentId: "sc-cad8f88c-10"
})(_templateObject10(), function(props) {
    return "calc(100vh - ".concat(props.heightLimiter, "px)");
});
var HeaderSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeaderSection",
    componentId: "sc-cad8f88c-11"
})(_templateObject11(), function(props) {
    return props.display;
}, function(props) {
    return props.border && "border-bottom: 0.5px solid rgba(255,255,255,0.07);";
}, function(props) {
    return props.justifyContent || "flex-start";
}, function(props) {
    return props.alignItems || "flex-start";
});
var HeaderExpandedList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderExpandedList",
    componentId: "sc-cad8f88c-12"
})(_templateObject12());
var HeaderExpandedListItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "HeaderExpandedListItem",
    componentId: "sc-cad8f88c-13"
})(_templateObject13());
var HeaderSectionList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderSectionList",
    componentId: "sc-cad8f88c-14"
})(_templateObject14());
var HeaderSectionListItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderSectionListItem",
    componentId: "sc-cad8f88c-15"
})(_templateObject15());
var MenuItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "MenuItem",
    componentId: "sc-cad8f88c-16"
})(_templateObject16(), function(props) {
    return props.margin || "0 0 0 20px";
}, function(props) {
    return props.secondaryColor;
});
var HeaderIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "HeaderIcon",
    componentId: "sc-cad8f88c-17"
})(_templateObject17(), function(props) {
    return props.display || "inline-block";
}, function(props) {
    return "".concat(props.size, "px") || 0;
}, function(props) {
    return "".concat(props.size, "px") || 0;
}, function(props) {
    return props.iconPointer ? "rotateZ(270deg)" : "rotateZ(90deg)";
});
// Desktop Dropdown Styles
var DesktopHeaderDropdown = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "DesktopHeaderDropdown",
    componentId: "sc-cad8f88c-18"
})(_templateObject18(), function(props) {
    return props.primaryColor || "#ffffff";
}, function(props) {
    return props.secondaryColor || "000000";
});
var DesktopDropdownItemList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DesktopDropdownItemList",
    componentId: "sc-cad8f88c-19"
})(_templateObject19());
var DesktopDropdownItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "DesktopDropdownItem",
    componentId: "sc-cad8f88c-20"
})(_templateObject20(), function(props) {
    return props.secondaryColor || "#000000";
});
var ShopingIconWrap = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ShopingIconWrap",
    componentId: "sc-cad8f88c-21"
})(_templateObject21());

// EXTERNAL MODULE: ./src/assets/svgExports/Arrow.js
var Arrow = __webpack_require__(674964);
// EXTERNAL MODULE: ./src/assets/svgExports/HeaderArrow.js
var HeaderArrow = __webpack_require__(273174);
// EXTERNAL MODULE: ./src/assets/svgExports/HeaderHome.js
var HeaderHome = __webpack_require__(452882);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(467313);
// EXTERNAL MODULE: ./src/assets/svgExports/OrderIcon.js
var OrderIcon = __webpack_require__(566974);
// EXTERNAL MODULE: ./src/assets/svgExports/SearchIcon.js
var SearchIcon = __webpack_require__(350127);
// EXTERNAL MODULE: ./src/assets/svgExports/SupermarketIcon.js
var SupermarketIcon = __webpack_require__(281431);
// EXTERNAL MODULE: ./src/assets/svgExports/UserIconDark.js
var UserIconDark = __webpack_require__(252514);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/showMegaMenu.js
var showMegaMenu = __webpack_require__(36408);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(586423);
// EXTERNAL MODULE: ./src/utils/commonToggleAuthModal.js
var commonToggleAuthModal = __webpack_require__(13605);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/emoticonsStatus.js
var emoticonsStatus = __webpack_require__(218626);
// EXTERNAL MODULE: ./src/components/Common/ReactHamburger/index.js + 1 modules
var ReactHamburger = __webpack_require__(70440);
// EXTERNAL MODULE: ./src/components/Common/WhatsAppIconComp/index.js
var WhatsAppIconComp = __webpack_require__(634098);
// EXTERNAL MODULE: ./src/utils/orderDropdownList.js
var orderDropdownList = __webpack_require__(20503);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(821448);
// EXTERNAL MODULE: ./src/utils/isClickOutside.js
var isClickOutside = __webpack_require__(853569);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(385126);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(336623);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var storeInfo = __webpack_require__(117321);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/logoAndNameHelpers.ts
var logoAndNameHelpers = __webpack_require__(273494);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(254051);
// EXTERNAL MODULE: ./src/utils/getActualOrDsStoreLogo.js
var getActualOrDsStoreLogo = __webpack_require__(168491);
// EXTERNAL MODULE: ./src/utils/getNavList.js
var getNavList = __webpack_require__(704956);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/isMobileDevice.ts
var isMobileDevice = __webpack_require__(826910);
// EXTERNAL MODULE: ./src/components/Wishlist/WishlistHeaderMenuItem.tsx
var WishlistHeaderMenuItem = __webpack_require__(155039);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/Header3/index.js







































var MegaMenuDesktopView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6065).then(__webpack_require__.bind(__webpack_require__, 546065)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(546065)
            ];
        }
    },
    ssr: false
});
var MegaMenuMobileView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 574).then(__webpack_require__.bind(__webpack_require__, 880574)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(880574)
            ];
        }
    },
    ssr: false
});
var Header = function(param) {
    var _primaryColor = param.primaryColor, primaryColor = _primaryColor === void 0 ? "#6E27FF" : _primaryColor, _secondaryColor = param.secondaryColor, secondaryColor = _secondaryColor === void 0 ? "#ffffff" : _secondaryColor, showStoreNameOnMobile = param.showStoreNameOnMobile, _hideCart = param.hideCart, hideCart = _hideCart === void 0 ? false : _hideCart;
    var clickExpandable = function clickExpandable() {
        setOpenCategory(!openCategory);
    };
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var toggleShowDesktopDropdown = function toggleShowDesktopDropdown() {
        setShowDesktopDropdown(!showDesktopDropdown);
    };
    var onHandleOrdersClick = function onHandleOrdersClick(href) {
        if ((user === null || user === void 0 ? void 0 : user.isLogin) && href === routes.PATH.ORDERS && deviceWidth/* deviceWidth */.o > 766) {
            toggleShowDesktopDropdown();
        } else {
            router.push((0,routes.getRoute)(routes.PATH.ORDERS, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
        }
    };
    var toggleShowDesktopDropdown = function toggleShowDesktopDropdown() {
        setShowDesktopDropdown(!showDesktopDropdown);
    };
    var renderUserIconDesktop = function renderUserIconDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                deviceWidth/* deviceWidth */.o > 766 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-3 pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt1",
                                onClick: function() {
                                    return onHandleOrdersClick(routes.PATH.ORDERS);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                                    color: "#000000",
                                    width: "24",
                                    height: "24"
                                })
                            })
                        }),
                        (user === null || user === void 0 ? void 0 : user.isLogin) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-3-arrow-img ml1 pointer " + (showDesktopDropdown ? "" : "rotate-180"),
                            onClick: toggleShowDesktopDropdown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderArrow/* HeaderArrow */.i, {
                                color: secondaryColor,
                                width: "10",
                                height: "10"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: ref6,
                            className: "br2 absolute shadow-2 z-5 header-3-orderdropdown-container" + (isVisitorLoginVisible ? "" : "-nologin"),
                            children: showDesktopDropdown && ordersDropdownList.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        item.id === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "header-3-orderdropdown-container-arrow"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "header-3-orderdropdown-container-item flex items-center z-5 " + (item.id === 3 ? "red " : "") + (item.id !== 1 && "pointer"),
                                            onClick: function(e) {
                                                return onHandleOrdersDropdown(item, e);
                                            },
                                            children: [
                                                item.id === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mr3 mt1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                                                        color: "black",
                                                        width: "33",
                                                        height: "33"
                                                    })
                                                }),
                                                item.name
                                            ]
                                        }, item.id)
                                    ]
                                });
                            })
                        })
                    ]
                }),
                showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                    toggleLogoutModal: toggleLogoutModal,
                    executeLogout: excuteLogout/* executeLogout */.q,
                    showLogoutConfirmation: showLogoutConfirmation
                })
            ]
        });
    };
    var renderUserIconMobile = function renderUserIconMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-3-mobile-login-navigation-container " + ((user === null || user === void 0 ? void 0 : user.isLogin) ? "red" : null),
                    onClick: toggleAuthModal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                            color: "#000000",
                            width: "22",
                            height: "22"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-translate-logout-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                            })
                        })
                    ]
                }),
                showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                    toggleLogoutModal: toggleLogoutModal,
                    executeLogout: excuteLogout/* executeLogout */.q,
                    showLogoutConfirmation: showLogoutConfirmation
                })
            ]
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useRef)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref7 = (0,react.useState)(0), height = ref7[0], setHeight = ref7[1];
    var ref8 = (0,react.useState)(false), isOpen = ref8[0], setOpen = ref8[1];
    var headerRef = (0,react.useRef)(null);
    var ref9 = (0,react.useState)(false), openCategory = ref9[0], setOpenCategory = ref9[1];
    var ref10 = (0,react.useState)(false), openMore = ref10[0], setOpenMore = ref10[1];
    var ref11 = (0,react.useState)([]), shopCategory = ref11[0], setShopCategory = ref11[1];
    var ref12 = (0,react.useState)(false), showLogoutConfirmation = ref12[0], setShowLogoutConfirmation = ref12[1];
    var ref13 = (0,react.useState)(false), showDesktopDropdown = ref13[0], setShowDesktopDropdown = ref13[1];
    var ref14 = (0,react.useState)(false), isHeaderRef = ref14[0], setHeaderRef = ref14[1];
    var ref15 = (0,react.useState)(false), scrolled = ref15[0], setScrolled = ref15[1];
    var store = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer;
    }).store;
    var store_info = store.store_info, services = store.services;
    var storeLogo = (0,getActualOrDsStoreLogo/* default */.Z)(store);
    var theme = store.theme;
    var themeColor = theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var ref16 = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store,
            user: state.userReducer,
            items: state.cartReducer.items,
            catalog: state.catalogReducer
        };
    }), user = ref16.user, items = ref16.items, _catalog = ref16.catalog, categories = _catalog.categories, productTags = _catalog.productTags;
    var ordersDropdownList = (0,orderDropdownList/* default */.Z)();
    var visitorLoginFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().visitorLoginFeatureStatus;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    // useSaveHeaderHeight(headerRef);
    (0,react.useEffect)(function() {
        setOpen(false);
        setShowLogoutConfirmation(false);
    }, [
        user === null || user === void 0 ? void 0 : user.isLogin
    ]);
    (0,react.useEffect)(function() {
        if (!isHeaderRef && headerRef.current) {
            setHeight(headerRef.current.offsetHeight);
            setHeaderRef(true);
        }
        if (categories && categories.length > 0) {
            var categoryTemp = categories.filter(function(el) {
                return el.id !== 0;
            });
            setShopCategory((0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categoryTemp)));
        }
    }, [
        categories
    ]);
    var handleScroll = function() {
        if (headerRef.current) {
            setScrolled(headerRef.current.getBoundingClientRect().top <= 1);
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function() {
            return handleScroll();
        }, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", function() {
                return handleScroll();
            }, {
                passive: true
            });
        };
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref6
    ]);
    var toggleAuthModal = function() {
        if ((0,commonToggleAuthModal/* commonToggleAuthModal */.D)({
            userLogin: user === null || user === void 0 ? void 0 : user.isLogin,
            storeInfoDomain: store_info === null || store_info === void 0 ? void 0 : store_info.domain
        })) toggleLogoutModal();
    };
    var onHandleOrdersDropdown = function(item) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        switch(item.action){
            case constants/* ORDERS_DROPDOWN_LIST.MY_ORDERS */.Bm.MY_ORDERS:
                {
                    toggleShowDesktopDropdown();
                    router.push((0,routes.getRoute)(routes.PATH.ORDERS, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                    break;
                }
            case constants/* ORDERS_DROPDOWN_LIST.LOGOUT */.Bm.LOGOUT:
                {
                    toggleLogoutModal();
                    break;
                }
            case constants/* ORDERS_DROPDOWN_LIST.DEFAULT_PHONE */.Bm.DEFAULT_PHONE:
                {
                    break;
                }
            default:
                {
                    break;
                }
        }
    };
    var handleClickOutside = function(e) {
        var callback = function() {
            return setShowDesktopDropdown(false);
        };
        (0,isClickOutside/* commonOutsideClick */.C)({
            event: e,
            pathNo: 0,
            ref: ref6,
            callback: callback
        });
    };
    var handleCartClick = function() {
        if ((0,getStoreType/* getStoreType */.K)({
            services: services
        }) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B) {
            dispatch((0,storeInfo/* toggleRfqFormModal */.H4)());
            return;
        }
        router.push((0,routes.getRoute)(routes.PATH.CART, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    /**
   * Render cartIcon
   * @return {JSX}
   */ var _renderCartIcon = function() {
        return items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pl2 pb2 pt3 pr3 br3",
            style: {
                backgroundColor: secondaryColor
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopingIconWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupermarketIcon/* SupermarketIcon */.N, {
                        color: themeColor,
                        width: "20",
                        height: "20"
                    }),
                    items && items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartTotalContainer, {
                        backgroundColor: themeColor,
                        fontColor: secondaryColor,
                        children: items.length
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: "pl2 pb2 pt2 pr3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopingIconWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupermarketIcon/* SupermarketIcon */.N, {
                    color: secondaryColor,
                    width: "20",
                    height: "20"
                })
            })
        });
    };
    return theme ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderComponent, {
        primaryColor: themeColor,
        secondaryColor: secondaryColor,
        ref: headerRef,
        scrolled: scrolled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderInner, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSections, {
                        style: {
                            flex: "1 1 100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileHeader, {
                                style: {
                                    flex: "1 1 100%",
                                    paddingRight: 20,
                                    paddingLeft: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactHamburger["default"], {
                                            open: isOpen,
                                            setOpen: setOpen,
                                            theme: secondaryColor
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                                        style: {
                                            paddingLeft: 10
                                        },
                                        showStoreNameOnMobile: showStoreNameOnMobile,
                                        fontColor: secondaryColor,
                                        onClick: function() {
                                            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                        },
                                        children: store_info === null || store_info === void 0 ? void 0 : store_info.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopHeader, {
                                style: {
                                    flex: "1 1 100%",
                                    paddingRight: 20,
                                    maxWidth: "45vw"
                                },
                                children: [
                                    storeLogo && (0,logoAndNameHelpers/* getVisibilityForHeader */.g)(theme === null || theme === void 0 ? void 0 : theme.store_logo_status) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "header-logo-image mr3 pointer",
                                        src: storeLogo,
                                        alt: "store logo",
                                        onClick: function() {
                                            (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain);
                                            setOpenCategory(false);
                                        }
                                    }),
                                    (0,logoAndNameHelpers/* getVisibilityForHeader */.g)(theme === null || theme === void 0 ? void 0 : theme.store_name_status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                                        onClick: function() {
                                            (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain);
                                            setOpenCategory(false);
                                        },
                                        fontColor: secondaryColor,
                                        children: store_info === null || store_info === void 0 ? void 0 : store_info.name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSections, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        onClick: function() {
                                            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                            setOpenCategory(false);
                                        },
                                        children: "Home"
                                    }),
                                    (theme === null || theme === void 0 ? void 0 : (ref1 = theme.cta_config) === null || ref1 === void 0 ? void 0 : ref1.header_cta) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            position: "relative"
                                        },
                                        onClick: clickExpandable,
                                        children: [
                                            theme === null || theme === void 0 ? void 0 : (ref2 = theme.cta_config) === null || ref2 === void 0 ? void 0 : ref2.header_cta,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon, {
                                                display: "flex",
                                                size: 12,
                                                iconPointer: openCategory,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* Arrow */.E, {
                                                    color: secondaryColor
                                                })
                                            }),
                                            !(0,showMegaMenu/* showMegaMenu */.G)() && openCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopHeaderDropdown, {
                                                primaryColor: themeColor,
                                                secondaryColor: "#ffffff",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopDropdownItemList, {
                                                    children: shopCategory.map(function(cat) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(DesktopDropdownItem, {
                                                            secondaryColor: "#ffffff",
                                                            onClick: function() {
                                                                setOpenCategory(false);
                                                                if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(theme === null || theme === void 0 ? void 0 : theme.theme_class)) {
                                                                    window.location.href = (0,routes.getRoute)("".concat(routes.PATH.SHOP, "?cid=").concat(cat.id), store_info === null || store_info === void 0 ? void 0 : store_info.domain);
                                                                } else {
                                                                    router.push((0,routes.getRoute)("".concat(routes.PATH.PRODUCT, "?cid=").concat(cat.id), store_info === null || store_info === void 0 ? void 0 : store_info.domain), undefined, {
                                                                        shallow: true
                                                                    });
                                                                }
                                                            },
                                                            children: (0,emoticonsStatus/* removeEmoticons */._)(cat.name)
                                                        }, "".concat(cat.name, "-").concat(cat.id));
                                                    })
                                                })
                                            })
                                        ]
                                    }) : null,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        onClick: function() {
                                            router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                        },
                                        children: "About Us"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppIconComp/* DesktopWhatsAppComp */.u, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                margin: "0 0 0 25px",
                                onClick: function() {
                                    return router.push((0,routes.getRoute)(routes.PATH.SEARCH, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* SearchIcon */.W, {
                                    color: secondaryColor,
                                    size: "20",
                                    className: "".concat(hideCart ? "!tw-mr-2.5" : "")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeaderMenuItem/* default */.Z, {
                                    color: secondaryColor,
                                    showComponent: isMobile ? "icon" : "both",
                                    onClick: function() {
                                        return router.push((0,routes.getRoute)(routes.PATH.WISHLIST, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                    }
                                })
                            }),
                            !hideCart && (services === null || services === void 0 ? void 0 : services.store_flag) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                margin: "0 10px 0 25px",
                                onClick: handleCartClick,
                                children: _renderCartIcon()
                            }),
                            deviceWidth/* deviceWidth */.o > 766 && renderUserIconDesktop()
                        ]
                    })
                ]
            }),
            (0,showMegaMenu/* showMegaMenu */.G)() && deviceWidth/* deviceWidth */.o > 766 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuDesktopView, {
                open: openCategory,
                onClose: function() {
                    return setOpenCategory(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeader, {
                children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDropownContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeaderDrawer, {
                        paddingTop: height,
                        isOpen: isOpen,
                        primaryColor: themeColor,
                        secondaryColor: "#ffffff",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderDrawerInner, {
                            heightLimiter: height,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection, {
                                    border: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                                        margin: "0px",
                                        onClick: function() {
                                            setOpen(false);
                                            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    marginRight: 24,
                                                    marginLeft: 2
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderHome/* HeaderHome */.Q, {
                                                    color: secondaryColor,
                                                    width: true
                                                })
                                            }),
                                            "Home"
                                        ]
                                    })
                                }),
                                (theme === null || theme === void 0 ? void 0 : (ref3 = theme.cta_config) === null || ref3 === void 0 ? void 0 : ref3.header_cta) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderExpandable, {
                                    heightLimiter: height,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                            display: "flex",
                                            border: false,
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            onClick: clickExpandable,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                                                    margin: "0px",
                                                    children: [
                                                        (theme === null || theme === void 0 ? void 0 : (ref4 = theme.cta_config) === null || ref4 === void 0 ? void 0 : ref4.header_cta) === "Shop" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                marginRight: 24
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupermarketIcon/* SupermarketIcon */.N, {
                                                                color: secondaryColor,
                                                                width: 20,
                                                                height: 18
                                                            })
                                                        }),
                                                        theme === null || theme === void 0 ? void 0 : (ref5 = theme.cta_config) === null || ref5 === void 0 ? void 0 : ref5.header_cta
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon, {
                                                    size: 16,
                                                    iconPointer: openCategory,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* Arrow */.E, {
                                                        color: "#ffffff"
                                                    })
                                                })
                                            ]
                                        }),
                                        (0,showMegaMenu/* showMegaMenu */.G)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                paddingLeft: "50px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuMobileView, {
                                                open: openCategory,
                                                onClose: function() {
                                                    return setOpen(false);
                                                },
                                                primaryColor: themeColor,
                                                secondaryColor: secondaryColor
                                            })
                                        }) : openCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderExpandedList, {
                                            children: shopCategory.map(function(item) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(HeaderExpandedListItem, {
                                                    onClick: function() {
                                                        setOpen(false);
                                                        if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(theme === null || theme === void 0 ? void 0 : theme.theme_class)) {
                                                            router.push((0,routes.getRoute)("".concat(routes.PATH.SHOP, "?cid=").concat(item.id), store_info === null || store_info === void 0 ? void 0 : store_info.domain), undefined, {
                                                                shallow: true
                                                            });
                                                        } else {
                                                            router.push((0,routes.getRoute)("".concat(routes.PATH.PRODUCT, "?cid=").concat(item.id), store_info === null || store_info === void 0 ? void 0 : store_info.domain), undefined, {
                                                                shallow: true
                                                            });
                                                        }
                                                    },
                                                    children: (0,emoticonsStatus/* removeEmoticons */._)(item.name)
                                                }, "".concat(item.name, "-").concat(item.id));
                                            })
                                        })
                                    ]
                                }) : null,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection, {
                                    border: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSectionList, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSectionListItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeaderMenuItem/* default */.Z, {
                                                    color: secondaryColor,
                                                    iconPosition: "left",
                                                    wrapperClassName: "!tw-gap-[23px]",
                                                    customTextClassName: "!tw-text-[15px]",
                                                    onClick: function() {
                                                        return router.push((0,routes.getRoute)(routes.PATH.WISHLIST, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSectionListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderIcon/* OrderIcon */.c, {
                                                        secondaryColor: "#ffffff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                                        secondaryColor: "#ffffff",
                                                        onClick: function() {
                                                            router.push((0,routes.getRoute)(routes.PATH.ORDERS, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                        },
                                                        children: (0,getCustomCtaText/* default */.Z)("my_orders_cta")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppIconComp/* MobileWhatsAppComp */.A, {
                                                secondaryColor: "#ffffff"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSectionListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                                        size: 24,
                                                        secondaryColor: "#ffffff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                                        secondaryColor: "#ffffff",
                                                        onClick: function() {
                                                            router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                        },
                                                        children: "About Us"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                (0,getNavList/* showMyAccount */.p6)() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderExpandable, {
                                    heightLimiter: height,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                            display: "flex",
                                            border: false,
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            onClick: function() {
                                                return setOpenMore(!openMore);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                                    margin: "0px",
                                                    children: "More"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon, {
                                                    size: 16,
                                                    iconPointer: openMore,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* Arrow */.E, {
                                                        color: "#ffffff"
                                                    })
                                                })
                                            ]
                                        }),
                                        openMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderExpandedList, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderExpandedListItem, {
                                                onClick: function() {
                                                    return router.push((0,routes.getRoute)(routes.PATH.MY_ACCOUNT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                },
                                                children: "My Account"
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSectionList, {
                                        children: deviceWidth/* deviceWidth */.o < 767 && isVisitorLoginVisible && renderUserIconMobile()
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var Header3 = (Header);


/***/ }),

/***/ 13605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ commonToggleAuthModal; }
/* harmony export */ });
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(540190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


/**
 * common function to initiate auth toggle
 * @param {*} param0
 * @return {boolean} return
 */ var commonToggleAuthModal = function(param) {
    var userLogin = param.userLogin, storeInfoDomain = param.storeInfoDomain;
    if (userLogin) {
        return true;
    } else {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_0__.getRoute)(_routes__WEBPACK_IMPORTED_MODULE_0__.PATH.ORDERS, storeInfoDomain));
    }
    return false;
};


/***/ }),

/***/ 254051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ })

}]);